import angular from 'angular';
import _ from 'lodash';
import $ from 'jquery';
/* eslint-disable */
angular.module('webTools').directive('wtPropertyList', ['$compile', '$timeout', '$rootScope', 'Profiles', 'PropertyValues', 'ModalWindow',
    function ($compile, $timeout, $rootScope, Profiles, PropertyValues, ModalWindow) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: function(elem,attrs) {
                return attrs.template
            },
            scope: {
                profileName: '=',
                propertiesControl: '=',
                profilePropertyValues: '='
            },
            link: function (scope, element, attributes, ngModel) {
                scope.showProperties = false;
                scope.msapi = {};

                scope.internalControl = scope.propertiesControl || {};

                scope.resizeCalendar = (e) => {
                    let calendar = e.sender.dateView.calendar;
                    calendar.wrapper.width(e.sender.wrapper.width() - 6);
                }

                scope.internalControl.getPropertyValues = function (checkRequired, includeBlankValues, callback) {

                    var propertyValues = [];

                    element.find('.property-input:not(.k-widget)').each(function () {

                        var parent = $(this).closest('.property-control');
                        var propertyName = $(this).attr('name');
                        var isRequired = _.find(scope.properties, { name: propertyName }).required;

                        if ($(this).attr('wt-type') === 'multi') {

                            var textValue = $(this).find('.multiselect-input').val();

                            var multiValue = $(this).find('.multi-value').map(function (i, element) { return $(element).text() }).get().join(";");

                            if (textValue) { multiValue = multiValue ? multiValue + ';' + textValue : textValue }

                            var options = $(parent.find('select.property-operator')).data('kendoDropDownList');
                            var optionValue = options ? options.value() : '';

                            if (isRequired && checkRequired && multiValue.length === 0) {
                                ModalWindow.openNotification('Please enter value for property: ' + propertyName, callback());
                                propertyValues = false;
                                return false;
                            };

                            if (multiValue.length > 0 || includeBlankValues || optionValue === 'empty') {
                                propertyValues.push({
                                    propertyName: propertyName,
                                    propertyValue: optionValue === 'empty' ? '' : multiValue,
                                    propertyOperator: optionValue,
                                    propertyType: 'multi',
                                    required: isRequired
                                });
                            }
                        } else if ($(this).attr('wt-type') === 'date') {

                            var date1 = $(this).val();
                            var date2 = $(parent.find('input.date-two')).val() || '';
                            var options = $(parent.find('select.property-operator')).data('kendoDropDownList');
                            var optionValue = options ? options.value() : '';

                            if (isRequired && checkRequired && date1.length === 0) { ModalWindow.openNotification('Please enter value for property: ' + propertyName, callback()); propertyValues = false; return false; };

                            if (date1.length > 0 || date2.length > 0 || includeBlankValues || optionValue === 'empty') {
                                if (optionValue === 'between') {
                                    propertyValues.push({
                                        propertyName: propertyName,
                                        propertyValue: $(this).val(),
                                        propertyOperator: optionValue,
                                        propertyType: 'date'
                                    });
                                } else {
                                    propertyValues.push({
                                        propertyName: propertyName,
                                        propertyValue: date1,
                                        propertyOperator: optionValue,
                                        propertyType: 'date'
                                    });
                                }
                            }
                            if (optionValue === 'empty') {
                                propertyValues.push({
                                    propertyName: propertyName,
                                    propertyValue: '',
                                    propertyValue2: '',
                                    propertyOperator: optionValue,
                                    propertyType: 'date',
                                });
                            }
                        } else {
                            var inputValue = $(this).val();
                            var options = $(parent.find('select.property-operator')).data('kendoDropDownList');
                            var optionValue = options ? options.value() : '';

                            if (isRequired && checkRequired && inputValue.length === 0) { ModalWindow.openNotification('Please enter value for property: ' + propertyName, callback()); propertyValues = false; return false; };

                            if (inputValue.length > 0 || includeBlankValues || optionValue === 'empty') {
                                propertyValues.push({
                                    propertyName: propertyName,
                                    propertyValue: optionValue === 'empty' ? '' : $(this).val(),
                                    propertyOperator: optionValue,
                                    propertyType: 'text'
                                });
                            }
                        }
                    });

                    return propertyValues;
                }

                scope.propertyOptions = [
                    { text: '=', value: '=', selected: true },
                    { text: '<>', value: '<>' },
                    { text: '>', value: '>' },
                    { text: '<', value: '<' },
                    { text: '<=', value: '<=' },
                    { text: '>=', value: '>=' },
                    { text: 'Like', value: 'like' },
                    { text: 'Empty', value: 'empty' }
                ];

                scope.datePropertyOptions = [
                    { text: '=', value: '=', selected: true },
                    { text: '<>', value: '<>' },
                    { text: '>', value: '>' },
                    { text: '<', value: '<' },
                    { text: '<=', value: '<=' },
                    { text: '>=', value: '>=' },
                    { text: 'Like', value: 'like' },
                    { text: 'Between', value: 'between' },
                    { text: 'Empty', value: 'empty' }
                ];

                scope.$watch('properties', function () {
                    scope.showProperties = false;
                });

                scope.option = '=';

        scope.$on('propertiesDone', function () {
          $timeout(function () {
            scope.showProperties = true;
            scope.$emit('propertiesLoaded');
            scope.$broadcast('propertiesLoaded');
          });
        });

                scope.textOnBlur = function (e) {
                    $timeout(function () { $rootScope.$broadcast('propertyChanged', e.target.name); });
                }

                scope.textOnKeydown = function (e) {
                    switch (e.keyCode) {
                        case 13: // enter
                            $timeout(function () {
                                var inputList = angular.element('#propertyList').find('input');
                                inputList[inputList.index(e.target) + 1].focus();
                            })
                            e.preventDefault();
                            break;
                        default:
                            break;
                    }
                }

                scope.loadProperties = function (value) {

          scope.showProperties = false;

          if (typeof value != 'undefined') {
            if (!value || value === '[ Any Property ]') {
              //if (value === '[ Any Property ]') {
              scope.properties = [{ name: 'Any Property', type: 'text' }];
              var resetOptions = scope.$on('propertiesLoaded', function () {
                if (options) {
                  var options = $('input[name="Any Property"]').parent().find('select.property-operator').data('kendoDropDownList');
                  options.select(6);
                }
                resetOptions();
              })
            }
            else {
              if (value === '[ Any Profile ]') { value = 'anyprofile' }
              var folder = $rootScope.workingFolder !== 'locator search bar' ? $rootScope.workingFolder : '';
              Profiles.getProperties(folder, value).then((res) => {

                            let data = res.data;
                            
                            if (!_.isEmpty(scope.profilePropertyValues)) {
                                _.forEach(scope.profilePropertyValues, function (value, name) {

                                    var i = _.findIndex(data, { id: name });

                                    if (i > -1) {
                                        data[i].searchValue = value;
                                    }
                                })
                            }
                            scope.properties = data;
                            scope.showProperties = true;
                        });
                    }
                }


        }

        scope.$watch('profileName', function (value) {
          typeof value != 'undefined' && scope.loadProperties(value);
        })

                scope.$on('refreshProperties', function (e, value) {
                    scope.loadProperties(value);
                })


                scope.propertyName = '';
                scope.setPropertyName = function (e, propertyName) {
                    scope.propertyName = propertyName;
                }

                scope.getValues = function (propertyName) {

                    var currentValues = '';

                    if (scope.profileName !== '[ Any Profile ]' && scope.profileName !== '[ Any Property ]') {
                        $('#propertyList input:not(.k-input, .multiselect-input)').each(function () {
                            currentValues += $(this).attr('name') + '::' + $(this).val().length + ':' + $(this).val() + '[]';
                        });
                        $('#propertyList .multiselect').each(function () {
                            var multiValue = $(this).find('.multi-value').map(function (i, element) { return $(element).text() }).get().join(";");
                            currentValues += $(this).attr('name') + '::' + multiValue.length + ':' + multiValue + '[]';
                        })
                    }

                    return PropertyValues.getPropertyValues(scope.profileName, propertyName, currentValues.slice(0, -2));
                }
            }
        };
    }
]);
/* eslint-enable */
angular.module('webTools').service('PropertyValues', ['$q', '$http',
	function ($q, $http) {
	    return {
	        getPropertyValues: function (profileName, propertyName, currentValues) {

        var promises = {
          deferred: $q.defer(),
          canceler: $q.defer()
        }

        $http.post('/api/profiles/GetPropertyValues', { 'ProfileName': profileName, 'PropertyName': propertyName, 'CurrentValues': currentValues }, { timeout: promises.canceler.promise })
          .then(function (res) {
            promises.deferred.resolve(res.data);
          }).catch((res) => console.log(res.data))

        return promises;
      }
    }
  }
]);